<template>
  <transition name="fade" appear>
    <div class="video-controls">
      <!-- Play bar -->
      <div class="video-controls-timeline">
        <!-- Play pause -->
        <div class="controls-state" @click="$emit('state')">
          <svg  v-if="pause"  class="icon icon__pause" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 31 42">
            <path fill="#fff" d="M30.57 20.18l-29-20a1 1 0 0 0-1-.07A1 1 0 0 0 0 1v40a1 1 0 0 0 1 1 1 1 0 0 0 .57-.18l29-20A1 1 0 0 0 31 21a1 1 0 0 0-.43-.82z"/>
          </svg>

          <svg  v-if="play"  class="icon icon__play" xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 271.42 353.56">
            <path fill="#fff" d="M0 353.56h109V0H0zM162.42 0v353.56h109V0z"/>
          </svg>
        </div>
        <!-- Seek line -->
        <div class="controls-seek" @click.stop="seekVideo">
          <div class="seek-bar" ref="seek" :class="{seeking}">
            <span :style="{width: position + '%'}" />
          </div>
        </div>
        <!-- Volume control -->
        <div class="controls-mute" @click="$emit('mute')">
          <svg fill="#fff" class="icon icon__sound-on" v-if="!muted" xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 52.53 46.5">
            <path
              d="M28.78.43a3.3 3.3 0 0 0-3.34 0 1 1 0 0 0-.17.12L11.79 12H1.25A1.25 1.25 0 0 0 0 13.25v19a1.25 1.25 0 0 0 1.25 1.25h10.51l13.47 12.37a1 1 0 0 0 .21.15 3.25 3.25 0 0 0 1.71.48 3.37 3.37 0 0 0 3.35-3.4V3.41A3.39 3.39 0 0 0 28.78.43zM12.25 26A1.25 1.25 0 0 0 11 27.25V31H2.5V14.5H11v3.75a1.25 1.25 0 0 0 2.5 0v-4.42L26.77 2.6a.8.8 0 0 1 .78 0 .91.91 0 0 1 .45.8v39.7a.89.89 0 0 1-.45.79.79.79 0 0 1-.74 0L13.5 31.7v-4.45A1.25 1.25 0 0 0 12.25 26zM39.13 4.07a1.26 1.26 0 0 0-1.59.78 1.25 1.25 0 0 0 .78 1.59 17.23 17.23 0 0 1 0 32.63 1.25 1.25 0 0 0 .4 2.43 1.29 1.29 0 0 0 .4-.06 19.73 19.73 0 0 0 0-37.37z"/>
            <path
              d="M43.53 22.75a13.82 13.82 0 0 0-9.93-13.2 1.26 1.26 0 0 0-1.55.85 1.24 1.24 0 0 0 .11 1 1.21 1.21 0 0 0 .74.59 11.24 11.24 0 0 1 0 21.6 1.25 1.25 0 0 0 .35 2.41 1.06 1.06 0 0 0 .35 0 13.82 13.82 0 0 0 9.93-13.25z"/>
          </svg>

          <svg class="icon icon__sound-off" fill="#fff" v-if="muted" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30.5 46.52">
            <path d="M28.78.45a3.32 3.32 0 0 0-3.34 0l-.17.12L11.79 12H1.25A1.25 1.25 0 0 0 0 13.27v19a1.25 1.25 0 0 0 1.25 1.25h10.51l13.47 12.37a.8.8 0 0 0 .21.15 3.14 3.14 0 0 0 1.71.48 3.37 3.37 0 0 0 3.35-3.39V3.43A3.4 3.4 0 0 0 28.78.45zM12.25 26A1.25 1.25 0 0 0 11 27.27V31H2.5V14.52H11v3.75a1.25 1.25 0 0 0 2.5 0v-4.42L26.77 2.62a.83.83 0 0 1 .78 0 .92.92 0 0 1 .45.8v39.7a.88.88 0 0 1-.45.79.75.75 0 0 1-.74 0L13.5 31.72v-4.45A1.25 1.25 0 0 0 12.25 26z"/>
          </svg>

        </div>
      </div>
      <!-- Fullscreen -->
      <div class="video-controls-fullscreen" @click="$emit('fullscreen')">
        <svg fill="#fff" width="23" height="23" mlns="http://www.w3.org/2000/svg" viewBox="0 0 452 452">
          <path d="M0 148h20V20h128V0H0v148zM304 0v20h128v128h20V0H304zM20 304H0v148h148v-20H20V304zM432 432H304v20h148V304h-20v128z"/>
        </svg>
      </div>
    </div>
  </transition>
</template>
<script>

  const props = {
    play: {
      type: Boolean,
      default: false
    },
    pause: {
      type: Boolean,
      default: false
    },
    position: {
      type: Number,
      default: 0
    },
    duration: {
      type: Number,
      default: 0,
    },
    muted: {
      type: [Boolean, String],
      default: null,
    }
  };

  export default {
    props,
    data() {
      return {
        seeking: null,
      }
    },

    methods: {

      /**
       * Seek video to current position
       * Get div width and its offset from left
       *
       * @param e
       */
      seekVideo(e) {
        this.seeking = true;

        // Calculate position
        const total = this.$refs.seek.clientWidth;
        const position = e.offsetX || 0;
        const ratio = position / total;

        // Set position
        this.$emit('seek', this.duration * ratio);
        this.seeking = false;
      }

    }
  }

</script>

<style scoped lang="sass">
  .video-controls

    .icon__pause, .icon__play, .icon__sound-off, .icon__sound-on
      width: 16px
      height: 16px
    $height: 1rem
    $offset: 2.5rem
    position: absolute
    bottom: $offset
    left: $offset
    right: $offset
    height: $height
    display: flex
    align-items: center
    z-index: 10
    &.hidden
      opacity: 0
    &-timeline
      display: flex
      align-items: center
      width: 45%
      min-width: 200px
      .controls-state 
        margin-right: .5rem
        padding: .5rem
        color: white
      .controls-seek
        width: 100%
        padding: 1rem 0
        cursor: pointer
        .seek-bar
          width: 100%
          height: 2px
          background: #5a5a5a
          span
            display: block
            height: 100%
            width: 0
            background: white
            transition: width .3s
          &.seeking span
            transition: none
      .controls-mute
        padding: .5rem
        color: white
        margin-left: .5rem
        width: 1.35rem
        cursor: pointer
    &-fullscreen
      margin-left: auto
      color: white
      font-size: 1.65rem
      cursor: pointer
    @media screen and (max-width: 768px)
      &-timeline
        width: 100%
      &-fullscreen 
        display: none
</style>
